// 配列をnumberで指定した個数で分割する
// array = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]
// sliceByNumber(array, 3)
// => [[0, 1, 2], [3, 4, 5], [6, 7, 8], [9]]
export const sliceByNumber = (array, number) => {
  const length = Math.ceil(array.length / number)
  return new Array(length).fill().map((_, index) => array.slice(index * number, (index + 1) * number))
}
